import { useState, useEffect } from 'react';

// Module-scoped global search keyword (shared across components).
// The search input and the list hook live in different components, so a local
// useState here would give each its own copy and the keyword would never reach
// the filtering. Mirrors the store in useApplicationScreenshotsFilter.
let globalKeyword = '';
const keywordListeners: Set<(keyword: string) => void> = new Set();

const notifyKeywordChange = (keyword: string) => {
    globalKeyword = keyword;
    keywordListeners.forEach(listener => listener(keyword));
};

export const useApplicationScreenshotsSearch = () => {
    const [keyword, setKeyword] = useState<string>(globalKeyword);

    useEffect(() => {
        const listener = (newKeyword: string) => {
            setKeyword(newKeyword);
        };
        keywordListeners.add(listener);
        return () => {
            keywordListeners.delete(listener);
        };
    }, []);

    const handleFilterByKeyword = (newKeyword: string) => {
        notifyKeywordChange(newKeyword);
    };

    return {
        keyword,
        handleFilterByKeyword,
    };
};
